import React, { forwardRef, ForwardedRef } from 'react';
import styled from 'styled-components';
import { Button, Modal as ModalComponent } from '@tvg/fuse-design';

type Props = {
  open: boolean;
  onClose: (e: Event) => void;
  handleContinueShopping: (e: Event) => void;
  handleGoToBasket: (e: Event) => void;
};
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 218px;
  margin: auto;
`;

const ContinueButton = styled(Button)`
  margin-bottom: 18px;
`;

const Container = styled.div``;

const AddToBasketDialog = forwardRef((props: Props, ref: ForwardedRef<HTMLDivElement>) => {
  const { open, onClose, handleContinueShopping, handleGoToBasket } = props;

  return (
    <ModalComponent
      name="add_to_basket_dialog"
      open={open}
      onClose={onClose}
      title="Item added to basket"
      dataTestId="add_to_basket_dialog"
      srLabelCloseButton="close add to basket dialog"
      zIndex="25"
    >
      <ButtonContainer>
        <ContinueButton
          variant="tertiary"
          onClick={handleContinueShopping}
          dataTestId="continue_shopping_button"
          size="large"
          fullWidth
        >
          Continue shopping
        </ContinueButton>
        <Button
          href="/basket.page"
          onClick={handleGoToBasket}
          dataTestId="go_to_basket_button"
          size="large"
          variant="primary"
          fullWidth
        >
          Go to basket
        </Button>
      </ButtonContainer>

      <Container ref={ref} />
    </ModalComponent>
  );
});

export default AddToBasketDialog;
